type ChecklistItemProps = {
  title: string;
  description: string;
};

export function ChecklistItem({ title, description }: ChecklistItemProps) {
  return (
    <div className="flex">
      <div className="shrink-0">
        <div className="flex items-center justify-center">
          <span className="flex size-5 items-center justify-center rounded-full bg-indigo-500">
            <svg
              className="size-3 text-white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </span>
        </div>
      </div>
      <div className="-mt-0.5 ml-3">
        <dt className="font-medium text-gray-900 text-m leading-6">{title}</dt>
        <dd className="mt-1 text-gray-500 text-sm">{description}</dd>
      </div>
    </div>
  );
}
